import React, { useMemo, useState } from "react";
import { createForm, onFieldReact, onFieldValueChange } from "@formily/core";
import {
  Radio,
  FormItem,
  Input,
  Submit,
  DatePicker,
  FormButtonGroup,
} from "@formily/antd";
import { Card, Modal, Table } from "antd";
import "antd/lib/button/style";
import { FormProvider, Field } from "@formily/react";
import json2form from "../../unit/json2form";
import { request, requestkind } from "../../unit/request";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import * as datasource from "../../conf/datasource";
import { ImageUpload } from "../../components/upload";
import { GuaranteeSummary } from "../../components/Summary";

const GuaranteeAddPost = () => {
  const history = useHistory();
  const [errs, setErrs] = useState<any>({});
  const [showErr, setShowErr] = useState(false);
  const [partnerNumber, setPartnerNumber] = useState<string>();

  const form = useMemo(
    () =>
      createForm({
        validateFirst: true,
        effects() {
          onFieldReact("Website", (field) => {
            const CreditType = field.query("CreditType").value();
            field.hidden = CreditType === "CorpGuarantee" ? false : true;
          });
          onFieldReact("GuaranteeNumber", (field) => {
            const CreditType = field.query("CreditType").value();
            field.hidden = CreditType !== "Deposit" ? false : true;
          });
          onFieldReact("GuaranteeStartDate", (field) => {
            const CreditType = field.query("CreditType").value();
            field.hidden = CreditType !== "Deposit" ? false : true;
          });
          onFieldReact("GuaranteeEndDate", (field) => {
            const CreditType = field.query("CreditType").value();
            field.hidden = CreditType === "Deposit" ? true : false;
          });
          // onFieldReact('RecordFile', (field) => {
          //     const CreditType = field.query('CreditType').value()
          //     field.title = (CreditType === "Deposit") ? "打款凭证" : "电子版保函"
          // })
          // //打款凭证，当CreditType为Deposit时为必填项
          // onFieldValueChange('CreditType', (field) => {
          //     form.setFieldState('RecordFile', (state) => {
          //         state.required = field.value === "Deposit" ? true : false
          //     })
          // })
          onFieldReact("Guarantor", (field) => {
            const CreditType = field.query("CreditType").value();
            field.hidden = CreditType === "Deposit" ? true : false;
          });
        },
      }),
    []
  );

  const post = async (data: any) => {
    setLoading(true);
    const formdata = json2form(data);
    const json = await request(formdata, null, requestkind.GuaranteeAdd.Apply);
    console.log(json);
    setLoading(false);
    const { IsSuccess, Msg, Data, errors } = json;
    if (IsSuccess) {
      const { FlowID } = Data;

      Modal.success({
        title: "申请成功！",
        content: `FlowID:${FlowID}`,
        onOk: () => {
          console.log("goto ");
          history.push("/guaranteeAdd");
        },
      });
    } else {
      if (Msg) {
        Modal.error({
          title: "错误！",
          content: Msg,
        });
      }
      if (errors) {
        setErrs(errors);
        setShowErr(true);
      }
      setLoading(false);
    }
  };
  //进入页面，先获得当前的ParterInfo
  const getCurrentParterInfo = async () => {
    console.log("getting...");
    const json = await request(
      null,
      null,
      requestkind.Partner.CurrentParterInfo
    );
    const { PartnerNumber, PartnerName } = json.Data;
    console.log(json, PartnerNumber, PartnerName);
    form.setFieldState("PartnerNumber", (state) => {
      state.value = PartnerNumber;
    });
    form.setFieldState("PartnerName", (state) => {
      state.value = PartnerName;
    });
    setPartnerNumber(PartnerNumber);
  };
  useEffect(() => {
    getCurrentParterInfo();
  }, []);
  const [loading, setLoading] = useState<boolean>(false);
  return (
    <div>
      <Modal
        title="错误提示"
        visible={showErr}
        onOk={() => {
          setShowErr(false);
        }}
        onCancel={() => {
          setShowErr(false);
        }}
      >
        {(() => {
          const data: any = [];
          let i = 0;
          for (const key in errs) {
            i++;
            const err = errs[key];
            data.push({
              key: i,
              keyName: key,
              value: err,
            });
          }
          return (
            <Table
              pagination={false}
              dataSource={data}
              columns={[
                {
                  title: "字段名称",
                  dataIndex: "keyName",
                  key: "keyName",
                },
                {
                  title: "错误描述",
                  dataIndex: "value",
                  key: "value",
                },
              ]}
            />
          );
        })()}
      </Modal>
      <Card bordered={false}>
        {partnerNumber && <GuaranteeSummary partnerNumber={partnerNumber} />}
      </Card>
      <Card bordered={false}>
        <FormProvider form={form}>
          <Field
            name="PartnerNumber"
            title="合作伙伴编号"
            required
            display="hidden"
            validator={{ maximum: 20 }}
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <Field
            name="PartnerName"
            title="合作伙伴名称"
            required
            display="hidden"
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <Field
            name="CreditType"
            title="申请类型"
            required
            dataSource={datasource.CreditType}
            initialValue={datasource.CreditType[0].value}
            decorator={[FormItem]}
            component={[
              Radio.Group,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <Field
            name="PartnerType"
            title="使用类别"
            required
            hidden={true}
            dataSource={datasource.PartnerType}
            initialValue="LSP"
            decorator={[FormItem]}
            component={[
              Radio.Group,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />

          <Field
            name="GuaranteeNumber"
            title="保函编号"
            required
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />

          <Field
            name="GuaranteeStartDate"
            title="保函有效期开始时间"
            required
            decorator={[FormItem]}
            component={[
              DatePicker,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <Field
            name="GuaranteeEndDate"
            title="保函有效期结束时间"
            required
            decorator={[FormItem]}
            component={[
              DatePicker,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />

          <Field
            name="Amount"
            title="金额"
            required
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <Field
            name="Guarantor"
            title="担保方"
            required
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />

          <Field
            name="RecordFile"
            title="附件"
            required
            decorator={[FormItem]}
            component={[
              ImageUpload,
              {
                style: {
                  width: 488,
                },
              },
            ]}
          />

          <Field
            name="Website"
            title="网址"
            required
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />

          <Field
            name="Comment"
            title="备注"
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />

          {/* <Field
                        name="ChannelAgreementNumber"
                        title="渠道协议编号(v570)"
                        required
                        decorator={[FormItem]}
                        component={[
                            Input,
                            {
                                style: {
                                    width: 300,
                                },
                            },
                        ]}
                    />
                    <Field
                        name="ChannelAgreementName"
                        title="渠道协议名称"
                        required
                        decorator={[FormItem]}
                        component={[
                            Input,
                            {
                                style: {
                                    width: 300,
                                },
                            },
                        ]} 
                    /> */}

          <FormButtonGroup
            style={{
              marginLeft: "180px",
            }}
          >
            <Submit
              disabled={loading}
              onSubmit={(values) => {
                console.log(values);
                post(values);
              }}
            >
              {loading ? "正在提交" : "提交"}
            </Submit>
          </FormButtonGroup>
        </FormProvider>
      </Card>
    </div>
  );
};
export default GuaranteeAddPost;
